exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._sidebar .header-sidebar{background-color:#4d4d4d;padding:0!important}._sidebar .active{color:#dc2814}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/stylus-loader!./src/components/plain/sidebar/sidebar.styl
// module id = 420
// module chunks = 0